import './RcPill.css';
import { Rocket } from 'lucide-react';
import { RC_TYPES } from '../../pages/quality/promoteRun';

function RcPill({ type }) {
  return (
    <span className="te-rc-pill" title={`Current ${RC_TYPES[type].label} release candidate`}>
      <Rocket size={11} />
      RC
    </span>
  );
}

export default RcPill;
